<template>
  <li class="m-menu__item" :class="[{ 'm-menu__item--active' : active }, { 'm-menu__item--parent' : parent }]" aria-haspopup="true" >
    <router-link v-show="(name !== 'cargo_vehicular') || (name === 'cargo_vehicular' && features.cargo_property === 'true')" :to="validateRoute(name, link)" class="m-menu__link ">
      <i v-if="!parent" class="m-menu__link-bullet m-menu__link-bullet--dot">
        <span></span>
      </i>
      <span class="m-menu__link-text">
        {{ validateName(name, link) | translate | titleize }}
      </span>
    </router-link>
  </li>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  props: {
    active: { type: String, required: false },
    link: { type: String, required: true },
    name: { type: String, required: true },
    parent: { type: String, required: false },
    features: { type: Object, required: true } // is_condominium, is_cayena, cargo_property
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({shard: 'getUserShard'})
  },
  methods: {
    validateRoute (submenu_name, submenu_link) {
      var route = submenu_link
      // Validaciones
      if (submenu_name === 'staff') {
        if (this.features.is_condominium === 'true') {
          route = '/admin/staff-register-cond'
        }
      } else if (submenu_name === 'companies') {
        if (this.features.is_condominium === 'true') {
          route = '/admin/companies-cond'
        }
      }
      return route
    },
    validateName (submenu_name, submenu_link) {
      var name = submenu_name
      // Validaciones
      if (submenu_name === 'companies') {
        if (this.features.is_condominium === 'true') {
          name = 'houses'
        }
      }
      return name
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Submenu.vue